module.exports = __webpack_public_path__ + "1793882494189/fonts/summernote.f9b5d83.woff";